import { connect } from 'react-redux';
import Banner from 'brastrap/editorial/banner/Banner';

const mapStateToProps = ({
  browser,
  app: {
    routing: { pathname, search },
  },
}) => ({
  isDesktop: browser.deviceIs.desktop,
  isTablet: browser.deviceIs.tablet,
  isMobile: browser.deviceIs.mobile,
  pathname,
  search,
});

export default connect(mapStateToProps)(Banner);
